<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-2">
      <div class="breadcrumb-title mb-3 mt-md-0 mt-4">
        <app-list-header
          [title]="'APP_STORE.TITLE' | translate"
          icon="bx bx-store"
          [$parent]="getSelf()"
        >
          App Store
        </app-list-header>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="search-card compact-inputs">
            <div class="card-header search-card-header border-bottom-0">
              <button
                mat-stroked-button
                color="primary"
                class="ms-2"
                (click)="toggleSearch()"
                matTooltip=""
              >
                <mat-icon>tune</mat-icon>
                <span>{{ "APP_STORE.SEARCH.FILTER" | translate }}</span>
              </button>
              <button
                mat-stroked-button
                color="warn"
                class="ms-2"
                (click)="restoreColumnOrder()"
                [disabled]="!isColumnOrderChanged()"
                matTooltip="Restore Table Column Order"
                aria-label="Restore Table Column Order"
              >
                <mat-icon>restore</mat-icon>
                <span>{{ "APP_STORE.SEARCH.RESTORE" | translate }}</span>
              </button>
            </div>

            <div *ngIf="isExpanded" class="card-body pb-0">
              <div class="row mt-1">
                <!-- All Fields -->
                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="ms-1 flex-grow-1 dropdown-pd-none">
                      <mat-form-field appearance="outline" class="w-100">
                        <!-- <mat-label>Application Name</mat-label>
                                                <input matInput placeholder="" [(ngModel)]="applicationName"> -->
                        <mat-select
                          placeholder="{{
                            'APP_STORE.SEARCH.SELECT_FIELD' | translate
                          }}"
                          [(ngModel)]="searchData.field"
                        >
                          <mat-option
                            *ngFor="let item of fields"
                            [value]="item.value"
                          >
                            {{ item.label | translate }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <button
                      mat-icon-button
                      matTooltip="{{
                        'APP_STORE.SEARCH.Tooltip.Field' | translate
                      }}"
                      matTooltipPosition="above"
                      class="icon-center icon-clean"
                      aria-label="Application Name"
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>

                <!-- Operator -->
                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="ms-1 flex-grow-1 dropdown-pd-none">
                      <mat-form-field appearance="outline" class="w-100">
                        <!-- <mat-label>URL</mat-label>
                                                <input matInput placeholder="" [(ngModel)]="appUrl"> -->

                        <mat-select
                          placeholder="{{
                            'APP_STORE.SEARCH.SELECT_CONDITION' | translate
                          }}"
                          [(ngModel)]="searchData.condition"
                          (selectionChange)="onConditionChange()"
                        >
                          <mat-option
                            *ngFor="let op of operators"
                            [value]="op.value"
                          >
                            {{ op.label }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <button
                      mat-icon-button
                      matTooltip="{{
                        'APP_STORE.SEARCH.Tooltip.Operator' | translate
                      }}"
                      matTooltipPosition="above"
                      class="icon-center icon-clean"
                      aria-label="URL"
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>

                <!-- User Input -->
                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                  <div class="d-flex justify-content-start align-items-center">
                    <div class="ms-1 flex-grow-1 dropdown-pd-none">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{
                          "APP_STORE.SEARCH.ENTER_SEARCH_VALUE" | translate
                        }}</mat-label>
                        <input matInput [(ngModel)]="searchData.value" />
                      </mat-form-field>
                    </div>
                    <button
                      mat-icon-button
                      matTooltip="{{
                        'APP_STORE.SEARCH.Tooltip.Value' | translate
                      }}"
                      matTooltipPosition="above"
                      class="icon-center icon-clean"
                      aria-label=""
                    >
                      <mat-icon class="text-secondary icon-compact"
                        >info</mat-icon
                      >
                    </button>
                  </div>
                </div>

                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2">
                  <div class="d-flex gap-2 align-items-center">
                    <button
                      mat-stroked-button
                      color="primary"
                      class="ms-1"
                      (click)="addSearchData()"
                      [disabled]="!searchData.field || !searchData.condition"
                      matTooltip="Add search condition"
                    >
                      <mat-icon class="me-1">add</mat-icon>
                      {{ "APP_STORE.SEARCH.ADD" | translate }}
                    </button>
                    <button
                      mat-stroked-button
                      color="primary"
                      class="ms-1 d-flex align-items-center"
                      (click)="advanceSearch()"
                    >
                      <mat-icon class="me-1">search</mat-icon>
                      <span>{{ "APP_STORE.SEARCH.Search" | translate }}</span>
                    </button>
                    <button
                      mat-stroked-button
                      color="warn"
                      (click)="resetSearchCriteria(); display()"
                    >
                      <i class="fa fa-eraser eraser-warn-dark"></i>
                      <span class="ms-2">{{
                        "APP_STORE.SEARCH.RESET" | translate
                      }}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-auto mb-1 px-1 ms-2">
                  <mat-chip
                    *ngFor="let e of searchViewList; let i = index"
                    (click)="removeSearchData(i)"
                    class="m-1 filter-chip"
                    color="accent"
                  >
                    <ng-container [ngSwitch]="e.condition">
                      <span *ngSwitchCase="'Day'">
                        {{ e.field }} {{ e.condition }}:
                        {{ e.value?.split("-")[2] }}
                      </span>

                      <span *ngSwitchCase="'Month'">
                        {{ e.field }} {{ e.condition }}:
                        {{ e.value?.split("-")[1] }}
                      </span>

                      <span *ngSwitchCase="'Day & Month'">
                        {{ e.field }} Day: {{ e.value?.split("-")[2] }} Month:
                        {{ e.value?.split("-")[1] }}
                      </span>

                      <span *ngSwitchDefault>
                        {{ e.field }} {{ e.condition }} {{ e.value }}
                        {{ e.rangeFrom }} {{ e.rangeTo }}
                      </span>
                    </ng-container>

                    <button
                      matChipRemove
                      (click)="$event.stopPropagation(); removeSearchData(i)"
                      style="cursor: pointer"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-chip>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body shadow-none">
            <div class="table-container">
              <div class="table-responsive table-scrollable">
                <table class="table table-bordered table-sticky-header">
                  <thead>
                    <tr
                      cdkDropList
                      cdkDropListOrientation="horizontal"
                      [cdkDropListData]="displayedColumns"
                      (cdkDropListDropped)="drop($event)"
                    >
                      <th
                        *ngFor="let col of getCurrentColumns()"
                        cdkDrag
                        class="text-nowrap sortable-header"
                        [class.text-end]="col.key === 'action'"
                      >
                        <div class="header-content">
                          <!-- DRAG HANDLE -->
                          <span
                            class="drag-handle"
                            cdkDragHandle
                            (click)="$event.stopPropagation()"
                            >⋮⋮</span
                          >
                          <!-- LABEL + SORT -->
                          <span
                            class="header-label"
                            [class.not-sortable]="!col.sortable"
                            (click)="sortTable(col.key)"
                          >
                            {{ col.label | translate }}
                            <!-- SORT ICONS ONLY IF SORTABLE -->
                            <ng-container *ngIf="col.sortable">
                              <i
                                *ngIf="
                                  sortedField === col.key && sortOrder === 'ASC'
                                "
                                class="fa fa-sort-up ms-1"
                              ></i>
                              <i
                                *ngIf="
                                  sortedField === col.key &&
                                  sortOrder === 'DESC'
                                "
                                class="fa fa-sort-down ms-1"
                              ></i>
                              <i
                                *ngIf="sortedField !== col.key"
                                class="fa fa-sort ms-1 text-muted"
                              ></i>
                            </ng-container>
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let element of form.list; let i = index">
                      <td
                        *ngFor="let col of getCurrentColumns()"
                        [ngClass]="{
                          'text-center':
                            col.key === 'sno' || col.key === 'action',
                        }"
                      >
                        <ng-container [ngSwitch]="col.key">
                          <div *ngSwitchCase="'sno'" class="text-center">
                            {{ pageIndex(i) }}
                          </div>

                          <span *ngSwitchCase="'name'">
                            {{ element.name }}
                          </span>

                          <span *ngSwitchCase="'appUrl'">
                            {{ element.appUrl }}
                          </span>

                          <span *ngSwitchCase="'userName'">
                            {{ element.userName }}
                          </span>

                          <span *ngSwitchCase="'orgName'">
                            {{ element.orgName }}
                          </span>

                          <span
                            *ngSwitchCase="'action'"
                            class="d-flex justify-content-start"
                          >
                            <button
                              *ngIf="
                                element.bought && element.bought !== 'false'
                              "
                              mat-raised-button
                              color="primary"
                              disabled
                            >
                              <mat-icon class="me-1 icon-compact"
                                >shopping_cart</mat-icon
                              >
                              <small>{{ getAppStatus(element) }}</small>
                            </button>
                            <button
                              *ngIf="
                                !element.bought || element.bought === 'false'
                              "
                              class=""
                              mat-raised-button
                              color="primary"
                              (click)="buy(element)"
                            >
                              <mat-icon class="me-1 icon-compact"
                                >add_shopping_cart</mat-icon
                              >
                              <small>{{
                                "APP_STORE.SEARCH.Tooltip.Buy" | translate
                              }}</small>
                            </button>
                          </span>
                        </ng-container>
                      </td>
                    </tr>
                    <tr *ngIf="form.list.length === 0">
                      <td
                        [attr.colspan]="getCurrentColumns().length"
                        class="text-center py-4"
                      >
                        <div class="text-muted">
                          <i class="fas fa-inbox fa-2x mb-2"></i>
                          <p>No records found</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>